import { useCartStore } from 'stores/useCartStore';

export default function useCartRemove(lineId: string) {
  const removeFromCart = async () => {
    const response = await fetch('/api/cart/delete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ lineId })
    });

    const data = await response.json();
    useCartStore.setState({ cart: data.cart });
  };

  return removeFromCart;
}
